import { ThrowLiteError } from '../lite-error.js';
import { createTiCullState, destroyTiCullState, getComputeDispatchBatch, prepareTiCull, publishTiLodBucket } from './thin-instance-gpu-culling.js';

function tryBind(renderable, scene, mesh, engine, hasColor, excluded, baseUpdate, signature) {
  const ti = mesh.thinInstances;
  if (!ti) {
    return void 0;
  }
  if (ti._lodSource) {
    if (excluded) {
      ThrowLiteError(367);
    }
    renderable._direct = true;
    return bindLodPartner(ti, signature, hasColor, baseUpdate);
  }
  if (excluded || !ti._gpuCullingEnabled) {
    return void 0;
  }
  const holder = renderable;
  const cache = holder._tiCullStates ??= /* @__PURE__ */ new WeakMap();
  let state = cache.get(signature);
  if (!state) {
    state = createTiCullState();
    cache.set(signature, state);
    const owned = state;
    scene._meshDisposables.get(mesh)?.push(() => {
      destroyTiCullState(owned);
    });
  } else {
    state._localSphereReady = false;
  }
  const updateBatch = getComputeDispatchBatch(signature);
  const binding = {
    cullDrawBufs: null,
    _args: null,
    _updateBatch: updateBatch,
    update(context) {
      baseUpdate?.(context);
      const partner = ti._lodPartner ?? null;
      const res = prepareTiCull(engine, state, mesh, mesh._gpu, ti, hasColor, context, updateBatch, partner);
      binding.cullDrawBufs = res?.drawBuffers ?? null;
      binding._args = res?.argsBuffer ?? null;
      if (ti._lodBuckets) {
        publishTiLodBucket(ti, signature, res);
      }
    },
    draw(pass, indexCount, instanceCount) {
      if (binding._args) {
        pass.drawIndexedIndirect(binding._args, 0);
      } else if (ti._drawArgsBuffer) {
        pass.drawIndexedIndirect(ti._drawArgsBuffer, 0);
      } else {
        pass.drawIndexed(indexCount, instanceCount);
      }
    }
  };
  return binding;
}
function bindLodPartner(ti, signature, hasColor, baseUpdate) {
  const currentBucket = () => {
    const bucket = ti._lodBuckets?.get(signature);
    if (!bucket?.active) {
      return null;
    }
    if (hasColor && !bucket.colorBuffer) {
      ThrowLiteError(368);
    }
    return bucket;
  };
  const binding = {
    get cullDrawBufs() {
      return currentBucket();
    },
    get _args() {
      return currentBucket()?.argsBuffer ?? null;
    },
    _updateBatch: getComputeDispatchBatch(signature),
    update(context) {
      baseUpdate?.(context);
    },
    draw(pass, indexCount, instanceCount) {
      const bucket = currentBucket();
      if (bucket) {
        pass.drawIndexedIndirect(bucket.argsBuffer, 0);
      } else if (!ti._lodSource) {
        if (ti._drawArgsBuffer) {
          pass.drawIndexedIndirect(ti._drawArgsBuffer, 0);
        } else {
          pass.drawIndexed(indexCount, instanceCount);
        }
      }
    }
  };
  return binding;
}

export { tryBind };
//# sourceMappingURL=thin-instance-cull-binding.js.map
